export interface RecurringPaymentsState {
  recurringPayments: RecurringPayment[]
  loading: boolean
  error: string | null
  cancelPayment: {
    loading: boolean
    error: string | null
    id: string
  }
  recurringPaymentDetail: {
    loading: boolean
    error: string | null
    detail: RecurringPayment
  }
}

import { createReducer, PayloadAction } from '@reduxjs/toolkit'
import { RecurringPayment } from '@interfaces'
import {
  clearCancelPayment,
  clearRecurringPaymentsList,
  fetchRecurringPaymentDetail,
  fetchRecurringPayments,
  removeRecurringPayment,
} from './thunk'

const initialState: RecurringPaymentsState = {
  loading: false,
  error: null,
  recurringPayments: null,
  cancelPayment: {
    loading: null,
    error: null,
    id: null,
  },
  recurringPaymentDetail: {
    loading: null,
    error: null,
    detail: null,
  },
}

const reducers = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchRecurringPayments.pending, (acc) => {
      acc.loading = true
      acc.error = null
    })
    .addCase(
      fetchRecurringPayments.fulfilled,
      (acc, action: PayloadAction<RecurringPayment[]>) => {
        acc.recurringPayments = action.payload
        acc.loading = false
        acc.error = null
      },
    )
    .addCase(fetchRecurringPayments.rejected, (acc, { error }) => {
      acc.error = error.message
      acc.loading = false
      acc.recurringPayments = null
    })
    .addCase(removeRecurringPayment.rejected, (acc, { error }) => {
      acc.cancelPayment.loading = false
      acc.cancelPayment.error = error.message
    })
    .addCase(removeRecurringPayment.pending, (acc) => {
      acc.cancelPayment.loading = true
      acc.cancelPayment.error = null
    })
    .addCase(removeRecurringPayment.fulfilled, (acc, { meta: { arg: id } }) => {
      acc.cancelPayment.loading = false
      acc.cancelPayment.error = null
      acc.cancelPayment.id = id?.toString()
    })
    .addCase(clearCancelPayment, (acc) => {
      acc.cancelPayment.loading = null
      acc.cancelPayment.id = null
      acc.cancelPayment.error = null
    })
    .addCase(fetchRecurringPaymentDetail.rejected, (acc, { error }) => {
      acc.recurringPaymentDetail.loading = false
      acc.recurringPaymentDetail.error = error.message
    })
    .addCase(fetchRecurringPaymentDetail.pending, (acc) => {
      acc.recurringPaymentDetail.loading = true
      acc.recurringPaymentDetail.error = null
    })
    .addCase(fetchRecurringPaymentDetail.fulfilled, (acc, { payload }) => {
      acc.recurringPaymentDetail.loading = false
      acc.recurringPaymentDetail.error = null
      acc.recurringPaymentDetail.detail = payload
    })
    .addCase(clearRecurringPaymentsList, (acc) => {
      acc.error = null
      acc.loading = false
      acc.recurringPayments = null
    })
})

export default reducers
